<div class="card m-auto tarjeta-item">
  <section class="card-body pt-4">
    <header>
      <figure>
        <figcaption class="card-title h5">
          <strong>{{tarjeta.titulo}}</strong>
        </figcaption>
      </figure>
    </header>
    <ng-content></ng-content>
    <footer class="text-right tarjeta-item-link-pasos">
      <a (click)="viewDoc()" class="card-link text-body font-weight-bold pointer">
        Ver más
        <img  src="../../../../../assets/icons/circule-arrow-right.png" />
      </a>
    </footer>
  </section>
</div>
